import { useEffect, useState } from "react";
import { SingleValue } from "react-select";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { colourStyles } from './color-styles';

interface ITagSelectDropdownProps {
    tag: string;
    tagColor: string;
    onChange: (tag: string, tagColor: string) => void;
    validationGroup: IValidationGroup;
}
const noneTagLabel = 'None';
const tags = [
    { value: '', label: noneTagLabel },
    { value: '#4D79F6', label: 'Most common' },
    { value: '#8F51CE', label: 'Best value' },
];

const TagSelectDropdown: React.FC<ITagSelectDropdownProps> = ({ tag = '', tagColor = '', onChange, validationGroup }) => {
    const DefaultTagValue = {
        value: tagColor,
        label: tag || noneTagLabel
    }

    const [tagValue, setTagValue] = useState<SingleValue<IOption>>(DefaultTagValue);

    const onChangeHandler = (newValue: SingleValue<IOption>) => {
        setTagValue(newValue);
        if (newValue) {
            onChange(
                newValue?.label && newValue.label !== noneTagLabel ? newValue.label : '',
                newValue.value ? String(newValue.value) : ''
            );
        }
    }

    useEffect(() => {
        if (!tagValue?.value && tag && tagColor) {
            const value = {
                value: tagColor,
                label: tag
            }
            setTagValue(value);
        }
    },
        [tag, tagColor, tagValue]);

    return <SelectDropdown
        value={tagValue}
        options={tags}
        onChange={onChangeHandler}
        styles={colourStyles}
        validationGroup={validationGroup}
    />
}

export default TagSelectDropdown;
